import { Calendar } from "lucide-react";

export const NoReportingPeriodSelected = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="bg-primary/10 p-6 rounded-full mb-6">
        <Calendar className="h-12 w-12 text-primary" />
      </div>
      <h2 className="text-2xl font-semibold mb-2">
        No Reporting Period Selected
      </h2>
      <p className="text-muted-foreground mb-6 max-w-md">
        Please select a reporting period from the sidebar to view the relevant
        data and performance metrics for that time frame.
      </p>
    </div>
  );
};

export default NoReportingPeriodSelected;
